/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Style_Guide_Loaded_MessageInputs */

const en_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style guide loaded successfully`)
};

const fr_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide de style charge avec succes`)
};

const de_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styleguide erfolgreich geladen`)
};

const it_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida di stile caricata con successo`)
};

const ru_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководство по стилю успешно загружено.`)
};

const es_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía de estilo cargada exitosamente`)
};

const zh_cn2_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式指南已成功加载`)
};

const ja_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドが正常に読み込まれました`)
};

const hi_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड सफलतापूर्वक लोड हो गई`)
};

const pt_pt2_iframe_remote_style_guide_loaded_message = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia de estilo carregado com sucesso`)
};

/**
* | output |
* | --- |
* | "Style guide loaded successfully" |
*
* @param {Iframe_Remote_Style_Guide_Loaded_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_loaded_message = /** @type {((inputs?: Iframe_Remote_Style_Guide_Loaded_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Loaded_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_style_guide_loaded_message(inputs)
	if (locale === "de") return de_iframe_remote_style_guide_loaded_message(inputs)
	if (locale === "it") return it_iframe_remote_style_guide_loaded_message(inputs)
	if (locale === "ru") return ru_iframe_remote_style_guide_loaded_message(inputs)
	if (locale === "es") return es_iframe_remote_style_guide_loaded_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_style_guide_loaded_message(inputs)
	if (locale === "ja") return ja_iframe_remote_style_guide_loaded_message(inputs)
	if (locale === "hi") return hi_iframe_remote_style_guide_loaded_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_style_guide_loaded_message(inputs)
	return en_iframe_remote_style_guide_loaded_message(inputs)
});